const getters = {
  sidebar: (state) => state.app.sidebar,
  language: (state) => state.app.language,
  size: (state) => state.app.size,
  device: (state) => state.app.device,
  visitedViews: (state) => state.tagsView.visitedViews,
  cachedViews: (state) => state.tagsView.cachedViews,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  name: (state) => state.user.name,
  introduction: (state) => state.user.introduction,
  roles: (state) => state.user.roles,
  enterpriseName: (state) => state.user.enterpriseName,
  enterpriseId: (state) => state.user.enterpriseId,
  leftServeDayStr: (state) => state.user.leftServeDayStr,
  uniqueId: (state) => state.user.uniqueId,
  permission_routes: (state) => state.permission.routes,
  errorLogs: (state) => state.errorLog.logs,
};
export default getters;
